import { showGlobalDialogError } from "../components/error";
import { BASE_URL } from "../utils/constants";
import { clearAllLocalStorage } from "../utils/localStorageManager";

const getAccessToken = () => localStorage.getItem("accessToken");

const createHeaders = (customHeaders = {}) => {
	const token = getAccessToken();
	return {
		"Content-Type": "application/json",
		...(token && { Authorization: `Bearer ${token}` }),
		...customHeaders,
	};
};

export const apiClient = async (endpoint, { method = "GET", body = null, headers = {} } = {}) => {
	try {
		const response = await fetch(`${BASE_URL}${endpoint}`, {
			method,
			headers: createHeaders(headers),
			body: body ? JSON.stringify(body) : null,
		});

		if (response.status === 401) {
			const errorData = await response.clone().json().catch(() => ({}));
			if (errorData.exception === "Token expired") {
				const refreshResponse = await fetch(`${BASE_URL}/core/auth/openid-connect/refresh-token`, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						"token": getAccessToken(),
						"email": localStorage.getItem("userEmail")
					}
				});
				if (refreshResponse.ok) {
					const refreshData = await refreshResponse.json();
					let newToken = refreshData.access_token;

					localStorage.setItem("accessToken", newToken);

					// Retrigger initial API
					const retryResponse = await fetch(`${BASE_URL}${endpoint}`, {
						method,
						headers: {
							...createHeaders(headers),
							Authorization: `Bearer ${newToken}`
						},
						body: body ? JSON.stringify(body) : null,
					});

					if (!retryResponse.ok) {
						if (retryResponse.status === 401) clearAllLocalStorage();
						throw new Error(`API error: ${retryResponse.statusText}`);
					}
					return await retryResponse.json();
				} else {
					clearAllLocalStorage();
					return null;
				}
			}

			clearAllLocalStorage();
			return null; // Unauthorized case
		}
		if (response.status === 502) {
			showGlobalDialogError('Service Unavailable', 'We’re having trouble reaching the server. Please try again.');
		};

		if (!response.ok) {
			throw new Error(`API error: ${response.statusText}`);
		}

		return await response.json(); // Assuming all responses return JSON
	} catch (error) {
		console.error(`Error in API call to ${endpoint}:`, error);
		return null; // Handle gracefully
	}
};
